import { useEffect, useRef } from 'react';
import type { VirtuosoProps } from 'react-virtuoso';
import { Virtuoso } from 'react-virtuoso';
import { useVirtualScroll } from './hooks';
import type { ScrollbarsProps } from './Scrollbars';
import { Scrollbars } from './Scrollbars';

type Props<T> = VirtuosoProps<T, any> & {
  scrollbarProps?: ScrollbarsProps;
};

type Component = <T>(props: Props<T>) => React.ReactElement;

export const VirtualScroll: Component = ({ data, scrollbarProps, ...rest }) => {
  const { dataRef, virtuosoRef } = useVirtualScroll();

  const viewportRef = useRef<HTMLDivElement>(null);

  const scrollerRef = (el: any) => {
    viewportRef.current = el;
  };

  useEffect(() => {
    dataRef.current = data;
  }, [data, dataRef]);

  return (
    <Scrollbars viewportRef={viewportRef} {...scrollbarProps}>
      <Virtuoso
        data={data}
        ref={virtuosoRef}
        scrollerRef={scrollerRef}
        skipAnimationFrameInResizeObserver
        {...rest}
      />
    </Scrollbars>
  );
};
